import { CouponIcon } from 'assets/icons';
import { CouponType } from 'features/customerPanel/cpCoupons/interface';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { SectionNavigation } from 'shared/constants/common';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';

interface Props {
	redirectTo: string;
	couponCount: number;
}

const HeaderCouponBtn: React.FC<Props> = (props) => {
	const { redirectTo, couponCount } = props;
	const { generateViewHash } = useSectionNavigation();

	return (
		<>
			<NavLink
				exact
				to={{
					pathname: redirectTo,
					hash: generateViewHash(SectionNavigation.COUPON_LIST, { type: CouponType.IN_GAME, page: 1 }),
				}}
				data-cy="header-coupon"
			>
				<span className={`header-button--round header-button--round-text header-coupon-details`}>
					<CouponIcon />
					{couponCount > 0 && (
						<span className="count header-button--round__count header-button--round__count-text position--absolute">{couponCount}</span>
					)}
				</span>
			</NavLink>
		</>
	);
};

export default HeaderCouponBtn;
